import { Accordion, AccordionTab } from 'primereact/accordion'
import { useEffect, useRef, useState } from 'react';
import { DevelopmentTemplate } from '../../../services/Template/development-template';
import { useFormik } from 'formik';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Api } from '../../../services/api';
import { get, set } from 'react-hook-form';
import "../PM TEMPLATE/PM_TEMPLATE.css";
import { FaCopy, FaPlus, FaSave, FaTrash } from 'react-icons/fa';
import { Toast } from 'primereact/toast';
// import html2canvas from 'html2canvas';
import { toPng } from 'html-to-image';
import { InputTextarea } from 'primereact/inputtextarea';

const DEVELOPMENT_MANAGER_TEMPLATE = ({ pmId }) => {

    const [Milestones, setMilestones] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]);
    const [Section9Array, setSection9Array] = useState([{ name: '', }]);
    const [ProjectBudget, setProjectBudget] = useState([1, 2, 3, 4,]);
    const [Section6Array, setSection6Array] = useState([{ name: '', }]);
    const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);
    const [isCopyBtnLoading, setIsCopyBtnLoading] = useState(false);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getProjectDetails();

        return () => {
            formik.handleSubmit();
        };
    }, [pmId]);

    //! ----------------------------------------------------------
    const getProjectDetails = () => {
        var url = Api.API_BASE_URL + 'development/get';
        formik.setFieldValue('project_name', pmId);
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify({ projectId: pmId }),

        })
            .then((response) => response.json())
            .then((Josn) => {
                if (Josn.error != '') {
                    formik.setFieldValue('dmId', 0);
                    if (Josn.projects.development_date) {
                        formik.setFieldValue(`section_3.0.plan_completion_date`, Josn.projects.development_date);
                        formik.setFieldValue(`section_3.29.plan_completion_date`, Josn.projects.receive_building_permit);
                        formik.setFieldValue(`section_3.29.current_forecast_completion_date`, Josn.projects.receive_building_permit_data);
                        formik.setFieldValue('projected_dp_date', Josn.projects.receive_building_permit_data);
                        formik.setFieldValue('purchase_close_date', Josn.projects.development_date);
                    }
                } else {

                    formik.setFieldValue('dmId', Josn.dm);

                    formik.setFieldValue('name', Josn.sec_1.name);

                    formik.setFieldValue('expected_date', Josn.sec_2.expected_date);
                    formik.setFieldValue('project_summary', Josn.sec_2.project_summary);
                    formik.setFieldValue('schedule', Josn.sec_2.schedule);
                    formik.setFieldValue('purchase_close_date', Josn.sec_2.purchase_close_date);
                    formik.setFieldValue('notes', Josn.sec_2.notes);
                    formik.setFieldValue('projected_dp_date', Josn.sec_2.projected_dp_date);
                    formik.setFieldValue('address_vp_comment', Josn.sec_2.address_vp_comment);
                    formik.setFieldValue('expected_date_vp_comment', Josn.sec_2.expected_date_vp_comment);
                    formik.setFieldValue('project_summary_vp_comments', Josn.sec_2.project_summary_vp_comments);

                    formik.setFieldValue('schedule_vp_comments', Josn.sec_2.schedule_vp_comments);

                    if (Josn.sec_3.length != 0) {
                        setMilestones(Josn.sec_3);
                        formik.setFieldValue('section_3', Josn.sec_3);
                    }

                    if (Josn.sec_4.length != 0) {
                        setSection9Array(Josn.sec_4);
                        formik.setFieldValue('section_4', Josn.sec_4);
                    }

                    if (Josn.sec_5.length != 0) {
                        setProjectBudget(Josn.sec_5);
                        formik.setFieldValue('section_5', Josn.sec_5);
                    }

                    if (Josn.sec_6.length != 0) {
                        setSection6Array(Josn.sec_6);
                        formik.setFieldValue('section_6', Josn.sec_6);
                    }
                    if (formik.values.section_3.length != 0) {

                        if (Josn.projects.development_date) {

                            if (formik.values.section_3[0].plan_completion_date == '0000-00-00') {
                                formik.setFieldValue(`section_3.0.plan_completion_date`, Josn.projects.development_date);
                            }
                            console.log('data sasd------', formik.values.section_3[29].plan_completion_date, Josn.projects.receive_building_permit_data);
                            if (formik.values.section_3[29].plan_completion_date == '0000-00-00') {
                                console.log('data sasd------', formik.values.section_3[29].plan_completion_date, Josn.projects.receive_building_permit_data);


                                formik.setFieldValue(`section_3.29.plan_completion_date`, Josn.projects.receive_building_permit_data);
                            }
                        }

                    }
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.error("Error:", error);
                setIsLoading(false);
            });
    }

    const toast = useRef(null);
    const formik = useFormik({
        initialValues: DevelopmentTemplate.getFormName(),
        validate: (data) => {
        },
        onSubmit: (data) => {
            if (!existPageWithoutSave) {
                return;

            }

            data.user_id = localStorage.getItem('user_id');
            data.role_id = localStorage.getItem('role_id');
            var url = Api.API_BASE_URL + 'development/save';

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setExistPageWithoutSave(false);
                    if (Josn.error != '') {
                        formik.setFieldValue('dmId', Josn.dm);
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        formik.setFieldValue('dmId', Josn.dm);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    });

    //! -----------------------
    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        
    };

    const cellStyle = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
    };

    const cellStylee = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        textAlign: 'end',
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px'

    };

    const borderStyle = {
    };

    const yesCellStyle = {
        ...cellStyle,
    };

    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };

    //! ----------------------------------------------------------
    const priceBodyTemplatee = (rowData) => {

        if (rowData === '' || rowData === null) {
            return '';
        }
        let numberValue = Number(rowData);
        if (isNaN(numberValue)) {
            return '';
        }

        const isNegative = rowData < 0;
        return <span style={{ color: isNegative ? "red" : "black", textAlign: "center !important", }}>
            {formatCurrency(rowData)}
        </span>
    };
    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    // ----------------------------------------------------------------------------
    const renderTextArea = (fieldName, placeholder, rowCount = 2, formData = '') => (
        <textarea
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            rows={rowCount}
            value={formData != '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                console.log(e.target.value)
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
        ></textarea>
    );

    const renderTextAreaFull = (fieldName, placeholder, rowCount = 2, formData = '') => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}

            autoResize
            id={fieldName}
            rows={rowCount}
            value={formData !== '' ? formData : formik.values[fieldName]}
            // value={formik.values[fieldName]}

            onChange={(e) => {
                console.log(e.target.value)
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
        ></InputTextarea>
    );

    const renderInputArea = (fieldName, placeholder, type = 'text', formData = '') => {
        if (type == 'date') {

            if (formData != null) {
                let timestamp = new Date(formData);



                if (!isNaN(timestamp.getTime())) {
                    formData = timestamp.toISOString().split('T')[0];
                }
            }
        }
        let backgroundColor = '';
        if (fieldName === 'section_3.0.plan_completion_date') {
            backgroundColor = '#FFE1FF';
        } else if (fieldName === 'section_3.29.current_forecast_completion_date') {
            backgroundColor = '#FFCFB3';
        } else if (fieldName === 'section_3.29.plan_completion_date') {
            backgroundColor = '#FFEB55';
        }


        return (
            <input
                type={type}
                placeholder={placeholder}
                name={fieldName}
                id={fieldName}
                value={formData != '' ? formData : formik.values[fieldName]}
                onChange={(e) => {
                    setExistPageWithoutSave(true);
                    formik.setFieldValue(fieldName, e.target.value);
                    console.log(fieldName);
                    if (fieldName === 'section_3.0.plan_completion_date') {
                        formik.setFieldValue('purchase_close_date', e.target.value)
                    } else if (fieldName === 'section_3.29.current_forecast_completion_date') {
                        formik.setFieldValue('projected_dp_date', e.target.value)
                    }

                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent form submission on Enter key press
                    }
                }}
                style={{
                    width: '100%',
                    height: '40px',
                    boxSizing: 'border-box',
                    border: 'none',
                   
                    textAlign: 'center',
                    marginTop: '0px',
                    backgroundColor: backgroundColor,
                }}
            />
        )
    };

    const renderInputAreaForAmount = (fieldName, formData = '') => (
        <InputNumber

            inputId="currency-us"
            className="text-center"
            inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            placeholder="$0.00"
            value={formData != '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.value)
            }
            }
            mode="currency"
            currency="USD"
            locale="en-US"
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault(); 
                }
            }}
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",
                textAlign: "center !important",
                marginTop: "0px",
                outline: 'none',
            }}
        />
    );


    const handleAddInputForMilestones = () => {
        setMilestones([...Milestones, 1]);
        formik.values.section_3.push(DevelopmentTemplate.getFormName().section_3[0]);
    };

    const handleDeleteInputForMilestones = (index) => {
        setMilestones([...Milestones, 2]);
        var newArray = [...Milestones];
        newArray.splice(index, 1);
        formik.values.section_3.splice(index, 1);
        setMilestones(newArray);
    };

    const handleAddInputForSection9Array = () => {
        setSection9Array([...Section9Array, { name: '', }]);
        formik.values.section_4.push({ activities_worked_on_this_week: '', contractor: '', brief_scope_of_work: '', current_f_c_date: '', vp_comments: '', });
    };

    const handleDeleteInputForSection9Array = (index) => {
        formik.values.section_4.splice(index, 1);
        setSection9Array([...Section9Array, { name: '', }]);
        const newArray = [...Section9Array];
        newArray.splice(index, 1);
        setSection9Array(newArray);
    };

    const handleAddInputForProjectBudget = () => {
        setProjectBudget([...ProjectBudget, 1]);
        formik.values.section_5.push(DevelopmentTemplate.getFormName().section_5[0]);
    };

    const handleDeleteInputForProjectBudget = (index) => {
        setProjectBudget([...ProjectBudget, 2]);
        var newArray = [...ProjectBudget];
        newArray.splice(index, 1);
        formik.values.section_5.splice(index, 1);
        setProjectBudget(newArray);
    };

    const handleAddInputForSection6Array = () => {
        setSection6Array([...Section6Array, { action_items_discussed: '', vp_comments: '' }]);
        formik.values.section_6.push({ action_items_discussed: '', vp_comments: '' });
    };

    const handleDeleteInputForSection6Array = (index) => {
        formik.values.section_6.splice(index, 1);
        setSection6Array([...Section6Array, { name: '', }]);
        const newArray = [...Section6Array];
        newArray.splice(index, 1);
        setSection6Array(newArray);
    };

    //* -------------------------
    const copyImageToClipboard = (blob) => {
        // Check if Clipboard API is available
        if (navigator.clipboard && navigator.clipboard.write) {
            navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: blob
                })
            ]).then(() => {
                setIsCopyBtnLoading(false);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
                console.log('Image copied to clipboard');
            }).catch((error) => {
                setIsCopyBtnLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
                console.error('Error copying image to clipboard:', error);
            });
        } else {
            setIsCopyBtnLoading(false);
            console.error('Clipboard API not available');
        }
    };
    const elementRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    const adjustTextareaHeight = (textarea) => {
        textarea.style.height = 'auto'; // Reset the height
        textarea.style.height = textarea.scrollHeight + 'px'; // Set the height to the scroll height
    };

    const expandAllTextareas = () => {
        elementRefs.forEach(ref => {
            if (ref.current) {
                const textareas = ref.current.querySelectorAll('textarea');
                textareas.forEach(adjustTextareaHeight);
            }
        });
    };

    // const takeScreenshotAndCopy = async () => {
    //     setIsCopyBtnLoading(true);
    //     console.log('Take screenshot and copy to clipboard');
    //     console.log('Take screenshot and copy to clipboard', elementRefs[0].current);

    //     try {
    //         const canvasPromises = elementRefs.map(async (ref) => {
    //             if (ref.current) {
    //                 return await html2canvas(ref.current);
    //             }
    //             return null;
    //         });

    //         const canvases = await Promise.all(canvasPromises);

    //         // Calculate total height of combined screenshots
    //         const totalHeight = canvases.reduce((acc, canvas) => acc + canvas.height, 0);

    //         // Create a new canvas to combine screenshots
    //         const combinedCanvas = document.createElement('canvas');
    //         combinedCanvas.width = Math.max(...canvases.map(canvas => canvas.width));
    //         combinedCanvas.height = totalHeight;

    //         // Draw screenshots onto the combined canvas
    //         const context = combinedCanvas.getContext('2d');
    //         let offsetY = 0;
    //         canvases.forEach(canvas => {
    //             context.drawImage(canvas, 0, offsetY);
    //             offsetY += canvas.height;
    //         });

    //         // Convert the combined canvas to a data URL
    //         const imageDataURL = combinedCanvas.toBlob(blob => {
    //             if (blob) {
    //                 // Copy blob to clipboard
    //                 copyImageToClipboard(blob);
    //             } else {
    //                 console.error('Error creating blob');
    //             }
    //         }, 'image/png');
    //         // const imageDataURL = combinedCanvas.toDataURL();

    //         // Do something with the data URL (e.g., display it, save it, etc.)
    //         console.log('Combined screenshot data URL:', imageDataURL);
    //     } catch (error) {
    //         setIsCopyBtnLoading(false);
    //         console.error('Error taking screenshots:', error);
    //     }

    // };

    const takeScreenshotAndCopy = async () => {
        setIsCopyBtnLoading(true);
        console.log('Take screenshot and copy to clipboard');

        try {
            // Expand all textareas to fit their content
            expandAllTextareas();

            const canvasPromises = elementRefs.map(async (ref) => {
                if (ref.current) {
                    return await toPng(ref.current, {
                        cacheBust: true,
                        pixelRatio: 2,
                    });
                }
                return null;
            });

            const images = await Promise.all(canvasPromises);

            // Create a new canvas to combine screenshots
            const combinedCanvas = document.createElement('canvas');
            const context = combinedCanvas.getContext('2d');

            // Calculate total height of combined screenshots
            let totalHeight = 0;
            let maxWidth = 0;
            for (const imgSrc of images) {
                const img = new Image();
                img.src = imgSrc;
                await new Promise((resolve) => {
                    img.onload = () => {
                        totalHeight += img.height;
                        if (img.width > maxWidth) maxWidth = img.width;
                        resolve();
                    };
                });
            }

            combinedCanvas.width = maxWidth;
            combinedCanvas.height = totalHeight;

            let offsetY = 0;
            for (const imgSrc of images) {
                const img = new Image();
                img.src = imgSrc;
                await new Promise((resolve) => {
                    img.onload = () => {
                        context.drawImage(img, 0, offsetY);
                        offsetY += img.height;
                        resolve();
                    };
                });
            }

            // Convert the combined canvas to a data URL
            combinedCanvas.toBlob(blob => {
                if (blob) {
                    copyImageToClipboard(blob);
                } else {
                    console.error('Error creating blob');
                }
            }, 'image/png');

        } catch (error) {
            setIsCopyBtnLoading(false);
            console.error('Error taking screenshots:', error);
        }
    };

    //* -------------------------


    return (
        <>
            <Toast ref={toast} />
            {isLoading ? (
                <div className="loading-spinner">
                    Loading...
                    <div className="spinner"></div>
                </div>
            ) : (

                <form onSubmit={formik.handleSubmit} className='pm-template-form' >
                    <div className='flex d-flex justify-content-end top-button'>
                        <Button className="m-2 mx-4 p-2 px-3 copySave-button" loading={isCopyBtnLoading} type="button" title="Copy Client Weekly Update" onClick={takeScreenshotAndCopy}>
                            <strong className="mr-2">Copy weekly update</strong>
                            <FaCopy />
                        </Button>

                        {/* <Button title='Save the Development Manager Playbook' className="m-2 mx-4 p-2 px-4 d-flex align-items-center customSave-button" type="submit">
                            <strong className="mr-2">Save</strong>
                            <i className="pi pi-save"></i>
                        </Button> */}
                        <button type="submit" title='Save the Development Manager Playbook' style={{ cursor: 'pointer' }} className="customSave-button m-2" >
                            <div className='flex gap-2 px-1 ' style={{ alignItems: 'center' }}>
                                <FaSave size={16} />
                                <span> SAVE </span>
                            </div>
                        </button>
                    </div>


                    <div className="cardd" style={{ border: 'none', }}>

                        <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5]}>
                            <AccordionTab header="DEVELOPMENT MANAGER PLAYBOOK" className="mt-2">

                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        {/* <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={2} >
                                                    Development Manager Playbook
                                                </th>
                                            </tr>

                                        </thead> */}

                                        <tbody>

                                            <tr>
                                                <td style={{ ...cellStyle, width: "300px", }} >
                                                    Name:
                                                </td>
                                                <td style={{ ...cellStyle, minWidth: "250px", padding: 0 }} >
                                                    {renderTextArea('name', '')}

                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                                <div className="table-container" style={{ overflowX: "auto", }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>

                                                <th style={{ ...headerStyle, minWidth: "auto" }} colSpan={3} >
                                                     Annual Deliverables:
                                                </th>
                                            </tr>

                                        </thead>

                                        <tbody>

                                            <tr>
                                                <td style={{ ...cellStyle, width: "300px", height: "24px", }} >
                                                    1) Identification of new developments
                                                </td>

                                                <td style={{ ...cellStyleW, minWidth: "auto", height: "24px" }} >
                                                    To identify new development opportunities that fit into the Lida Group. This also means developing and maintaining relationships with industry professionals
                                                </td>

                                                <td style={{ ...headerStyle, minWidth: "auto", height: "24px" }} >
                                                    We Are Team Players
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStyle, }} >
                                                    2) Analysis of highest and best use
                                                </td>

                                                <td style={{ ...cellStyleW, }} >
                                                    To review all new acquisitions for highest and best use. This encompasses determining the wants/needs of the various municipalities in order to not waste time pursuing plans that will not be approved
                                                </td>

                                                <td style={{ ...headerStyle, }} >
                                                    We Are Committed to Excellence
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStyle, }} >
                                                    3) Administration of the development process
                                                </td>

                                                <td style={{ ...cellStyleW, }} >
                                                    Organization and follow-up of the various stages of development including liasioning with consultants to push the project forward, submission of required paperwork, attending planning reviews, attending city council meetings, and reciept of building permits
                                                </td>

                                                <td style={{ ...headerStyle, }} >
                                                    We Do What We Say We Are Going To Do
                                                </td>

                                            </tr>

                                            <tr>
                                                <td style={{ ...cellStyle, padding: "10px", }} >
                                                    4) Schedule and budget
                                                </td>

                                                <td style={{ ...cellStyleW, }} >
                                                    Create, monitor and report on project schedule and budget paying particular attention to delays and unbudgeted expenses
                                                </td>

                                                <td style={{ ...headerStyle, }} >

                                                </td>

                                            </tr>



                                        </tbody>
                                    </table>
                                </div>

                            </AccordionTab>

                            <AccordionTab header="ACTION STEPS" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[1]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "300px" }}>
                                                    Action Steps: 
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Development Manager Comments 
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                  Companies Comments
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>


                                            <tr>
                                                <td style={borderStyle}>Expected Start Date:</td>

                                                <td style={{ ...borderStyle, backgroundColor: 'white' }}>

                                                    <input
                                                        type="date"
                                                        name="expected_date"
                                                        id="expected_date"
                                                        value={formik.values.expected_date}
                                                        onChange={(e) => {
                                                            setExistPageWithoutSave(true);
                                                            formik.setFieldValue('expected_date', e.target.value)
                                                        }}
                                                        style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none',  textAlign: 'center', }} />
                                                </td>
                                                <td style={cellStyleW} rowSpan={3} >
                                                    {renderTextAreaFull('address_vp_comment', '', 2,)}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={borderStyle}>Project Summary:</td>
                                                <td style={{ ...cellStyleW }}  >
                                                    {renderTextAreaFull('project_summary', '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={borderStyle}>Schedule:
                                                </td>
                                                <td style={borderStyle}>Purchase close date
                                                    <input
                                                        type="date"
                                                        name="purchase_close_date"
                                                        id="purchase_close_date"
                                                        value={formik.values.purchase_close_date}
                                                        readOnly
                                                        onChange={(e) => {
                                                            setExistPageWithoutSave(true);
                                                            formik.setFieldValue('purchase_close_date', e.target.value)
                                                        }}
                                                        style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none',  textAlign: 'center', backgroundColor: '#FFE1FF' }}
                                                    />
                                                    Projected DP date
                                                    <input
                                                        type="date"
                                                        name="projected_dp_date"
                                                        id="projected_dp_date"
                                                        value={formik.values.projected_dp_date}
                                                        readOnly
                                                        onChange={(e) => {
                                                            setExistPageWithoutSave(true);
                                                            formik.setFieldValue('projected_dp_date', e.target.value)
                                                        }}
                                                        style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none',  textAlign: 'center', backgroundColor: '#96CEB4' }} />

                                                </td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="SCHEDULE MILESTONES" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[2]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "300px" }}>
                                                    Schedule Milestones
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Plan Completion Date
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Current Forecast Completion Date
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Actual Completion Date
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Notes:  If applicable, explain why there was a change to the schedule
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Companies Comments
                                                </th>
                                                <th style={{ ...headerStyle, width: "80px", textAlign: 'center' }}>Add Remove Rows
                                                </th>

                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Milestones.map((item, index) => (
                                                <tr >
                                                    <td style={cellStyleW}>
                                                        {renderTextArea(`section_3.${index}.schedule_milestones`, '', 2, formik.values.section_3[index].schedule_milestones)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderInputArea(`section_3.${index}.plan_completion_date`, '', 'date', formik.values.section_3[index].plan_completion_date)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderInputArea(`section_3.${index}.current_forecast_completion_date`, '', 'date', formik.values.section_3[index].current_forecast_completion_date)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderInputArea(`section_3.${index}.actual_completion_date`, '', 'date', formik.values.section_3[index].actual_completion_date)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_3.${index}.notes`, '', 2, formik.values.section_3[index].notes)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_3.${index}.vp_comments`, '', 2, formik.values.section_3[index].vp_comments)}
                                                    </td>

                                                    <td style={cellStyleW}>

                                                        {index != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForMilestones(index)} />) : null}

                                                        {Milestones.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForMilestones()} />) : null}
                                                    </td>



                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="ACTIVITIES WORKED ON THIS WEEK" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[3]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "300px" }}>
                                                    Activities worked on this week: (Description)
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Contractor
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Brief Scope of Work
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Current Forecasted Completion Date
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Companies Comments
                                                </th>
                                                <th style={{ ...headerStyle, width: "80px" }}>
                                                    Add Remove Rows
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>

                                            {Section9Array.map((item, index) => (
                                                <tr>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_4.${index}.activities_worked_on_this_week`, '', 2, formik.values.section_4[index].activities_worked_on_this_week)}</td>

                                                    <td style={cellStyleW}>{renderTextArea(`section_4.${index}.contractor`, '', 2, formik.values.section_4[index].contractor)}</td>

                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_4.${index}.brief_scope_of_work`, '', 2, formik.values.section_4[index].brief_scope_of_work)}
                                                    </td>

                                                    <td style={cellStyleW}>
                                                        {renderInputArea(`section_4.${index}.current_f_c_date`, '', 'date', formik.values.section_4[index].current_f_c_date)}
                                                    </td>

                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_4.${index}.vp_comments`, '', 2, formik.values.section_4[index].vp_comments)}</td>

                                                    <td style={cellStyleW}>

                                                        {Section9Array.length != 1 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection9Array(index)} />) : null}

                                                        {Section9Array.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection9Array()} />) : null}

                                                    </td>
                                                </tr>
                                            ))}


                                        </tbody>


                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="PROJECT BUDGET" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[4]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Project Budget
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Amount
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Companies Comments
                                                </th>
                                                <th style={{ ...headerStyle, width: "80px", textAlign: 'center' }}>Add Remove Rows
                                                </th>

                                            </tr>
                                        </thead>

                                        <tbody>
                                            {ProjectBudget.map((item, index) => (
                                                <tr>
                                                    <td style={cellStyleW} >
                                                        {renderTextArea(`section_5.${index}.project_budget`, '', 2, formik.values.section_5[index].project_budget)}

                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderInputAreaForAmount(`section_5.${index}.amount`, formik.values.section_5[index].amount)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_5.${index}.vp_comments`, '', 2, formik.values.section_5[index].vp_comments)}
                                                    </td>

                                                    <td style={cellStyleW}>
                                                        {index != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForProjectBudget(index)} />) : null}

                                                        {ProjectBudget.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForProjectBudget()} />) : null}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="table-container" style={{ overflowX: "auto" }}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Action Items Discussed
                                                </th>

                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Companies Comments
                                                </th>

                                                <th style={{ ...headerStyle, width: "80px" }}>
                                                    Add Remove Rows
                                                </th>

                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Section6Array.map((item, index) => (
                                                <tr>
                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_6.${index}.action_items_discussed`, '', 2, formik.values.section_6[index].action_items_discussed)}
                                                    </td>

                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_6.${index}.vp_comments`, '', 2, formik.values.section_6[index].vp_comments)}
                                                    </td>


                                                    <td style={cellStyleW}>
                                                        {index != 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForSection6Array(index)} />) : null}

                                                        {Section6Array.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForSection6Array()} />) : null}

                                                    </td>



                                                </tr>
                                            ))}

                                        </tbody>


                                    </table>
                                </div>
                            </AccordionTab>
                        </Accordion>
                    </div>

                </form>
            )}
        </>
    )
}

export default DEVELOPMENT_MANAGER_TEMPLATE




// ---------------------------------------------------------------------
